<mat-form-field appearance="fill">
    <div class="input-group mb-3">
        <input class="form-control" matInput #onDatePicked  (dateInput)="addNewItem('input', $event)" (dateChange)="addNewItem('change', $event)"  [matDatepicker]="picker">
        <div class="input-group-append">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </div>
        <mat-datepicker #picker></mat-datepicker>
    </div>
</mat-form-field>
